import { Route, BrowserRouter as Router, Switch } from 'react-router-dom';
import AntaresLanding from './pages/AntaresLanding';
import ExperienceTimeline from './pages/ExperienceTimeline';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfUse from './pages/TermsOfUse';
import FieldResearchPage from './pages/FieldResearchPage';
import QRCodePage from './pages/QRCodePage';
import AdminPesquisasPage from './pages/admin/AdminPesquisasPage';
import AdminRegistrosPage from './pages/admin/AdminRegistrosPage';
import AdminLeadsPage from './pages/admin/AdminLeadsPage';
import AdminLayout from './pages/admin/AdminLayout';

function App() {
  return (
    <Router>
      <Switch>
        <Route exact path="/" component={AntaresLanding} />
        <Route path="/qrcode" component={QRCodePage} />
        <Route path="/experience" component={ExperienceTimeline} />
        <Route path="/termos" component={TermsOfUse} />
        <Route path="/privacidade" component={PrivacyPolicy} />
        <Route path="/pesquisa-campo" component={FieldResearchPage} />
        <Route path="/admin">
          <AdminLayout>
            <Switch>
              <Route path="/admin/pesquisas" component={AdminPesquisasPage} />
              <Route path="/admin/registros" component={AdminRegistrosPage} />
              <Route path="/admin/leads" component={AdminLeadsPage} />
            </Switch>
          </AdminLayout>
        </Route>
      </Switch>
    </Router>
  );
}

export default App;